import React, { useState, useContext, createContext } from 'react'
import { useLocalStorage } from '../hook'

export const AppContext = createContext()

export const AppProvider = ({ children }) => {
  const [activeGenre, setActiveGenre] = useLocalStorage('activeGenre', {})
  const [isPlaying, setIsPlaying] = useLocalStorage('isPlaying', false)

  const [hasChange, setHasChange] = useState(false)

  const [lastData, setLastData] = useState([])
  const [currentData, setCurrentData] = useState([])

  const ctxValue = {
    activeGenre,
    setActiveGenre,
    setIsPlaying,
    isPlaying,
    hasChange,
    setHasChange,
    setLastData,
    lastData,
    currentData,
    setCurrentData,
  }
  return <AppContext.Provider value={ctxValue}>{children}</AppContext.Provider>
}

export const useGlobalContext = () => useContext(AppContext)
